// GPS TRACKING CONSENT dialog — the officer explicitly answers "Can we track your
// location?" before the MDT starts (or stops) live location sharing. Additive.
import React from "react";
import { MapPin, TriangleAlert } from "lucide-react";
import { t } from "@/components/mdt/constants";

export function MdtGpsConsent({ mode, onClose, onAllow, onDisable }) {
  if (!mode) return null;
  const enable = mode === "enable";
  return (
    <div data-testid="mdt-gps-consent" className="fixed inset-0 z-[1000] flex items-center justify-center p-4"
      style={{ background: "rgba(0,0,0,0.72)" }} onClick={onClose}>
      <div className="w-full max-w-md rounded-lg border-2 p-5"
        style={{ background: t.head, borderColor: enable ? "#3B82F6" : t.red }}
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2.5 mb-3">
          {enable
            ? <MapPin size={22} style={{ color: "#60A5FA" }} />
            : <TriangleAlert size={22} style={{ color: "#f87171" }} />}
          <div className="font-head font-bold text-base text-white">
            {enable ? "CAN WE TRACK YOUR LOCATION?" : "TURN OFF LOCATION TRACKING?"}
          </div>
        </div>
        {enable ? (
          <div className="font-mono text-[11px] leading-relaxed" style={{ color: t.dim }}>
            This MDT will use your device location to:
            <ul className="list-disc ml-4 mt-1.5 space-y-1">
              <li>Display your position on your MDT map</li>
              <li>Show this unit LIVE to Dispatch for situational awareness</li>
              <li>Assist unit assignment, routing and smart on-scene arrival</li>
              <li>Support officer safety — Panic/Emergency transmits your position</li>
            </ul>
            <div className="mt-2">Your browser will ask for location permission next. Tracking stops when you sign off or turn GPS off here.</div>
          </div>
        ) : (
          <div className="font-mono text-[11px] leading-relaxed" style={{ color: t.dim }}>
            Dispatch will no longer see this unit's live position, breadcrumb trail updates stop,
            and Panic/Emergency will only carry your last known location. The opt-out is audited.
          </div>
        )}
        <div className="flex gap-2 mt-4">
          {enable ? (
            <>
              <button data-testid="mdt-gps-consent-allow" onClick={() => { onAllow(); onClose(); }}
                className="flex-1 py-2.5 rounded font-head font-bold text-sm text-white" style={{ background: "#3B82F6" }}>
                YES — TRACK MY LOCATION
              </button>
              <button data-testid="mdt-gps-consent-decline" onClick={onClose}
                className="px-4 py-2.5 rounded font-head font-bold text-sm" style={{ border: `1px solid ${t.border}`, color: t.dim }}>
                NOT NOW
              </button>
            </>
          ) : (
            <>
              <button data-testid="mdt-gps-consent-disable" onClick={() => { onDisable(); onClose(); }}
                className="flex-1 py-2.5 rounded font-head font-bold text-sm text-white" style={{ background: t.red }}>
                TURN OFF TRACKING
              </button>
              <button data-testid="mdt-gps-consent-keep" onClick={onClose}
                className="px-4 py-2.5 rounded font-head font-bold text-sm text-white" style={{ background: "#16A34A" }}>
                KEEP TRACKING
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
